import React, { useState } from "react";
import "./ShippingChoices.css";
import { FundraiserResponse } from "../../Interfaces/Fundraiser";
import {
  SHIP_TO_CUSTOMER,
  SHIP_TO_ORG,
  SHIP_TO_PARTICIPANT,
} from "../../CommonFunctions";

interface ShippingChoicesProps {
  shippingChoice: string;
  onShippingChoiceChange: (choice: string) => void;
  fundraiser: FundraiserResponse;
}

const ShippingChoices: React.FC<ShippingChoicesProps> = ({
  shippingChoice,
  onShippingChoiceChange,
  fundraiser,
}) => {
  const [isChanging, setIsChanging] = useState(false);

  const handleShippingChoiceChange = (choice: string) => {
    if (isChanging) return;
    setIsChanging(true);
    setTimeout(() => {
      onShippingChoiceChange(choice);
      setIsChanging(false);
    }, 400); // Slight delay to avoide changing options too fast and messing up the states
  };

  const getDisclaimerText = () => {
    if (shippingChoice === SHIP_TO_CUSTOMER) {
      return "Your order will be shipped soon.";
    } else if (
      shippingChoice === SHIP_TO_PARTICIPANT ||
      shippingChoice === SHIP_TO_ORG
    ) {
      return "Order will ship at the END of the fundraiser. Your participant will have your order.";
    }
    return "";
  };

  return (
    <div className="shipping-container">
      <h2 className="shipping-title">Select Shipping Method</h2>

      <label className="shipping-option">
        <input
          type="radio"
          value={SHIP_TO_CUSTOMER}
          checked={shippingChoice === SHIP_TO_CUSTOMER}
          onChange={() => handleShippingChoiceChange(SHIP_TO_CUSTOMER)}
          disabled={isChanging}
        />
        Ship to Customer
      </label>

      {fundraiser.allow_ship_to_participant && (
        <label className="shipping-option">
          <input
            type="radio"
            value={SHIP_TO_PARTICIPANT}
            checked={shippingChoice === SHIP_TO_PARTICIPANT}
            onChange={() => handleShippingChoiceChange(SHIP_TO_PARTICIPANT)}
            disabled={isChanging}
          />
          Ship to Participant
        </label>
      )}

      {fundraiser.allow_ship_to_org && (
        <label className="shipping-option">
          <input
            type="radio"
            value={SHIP_TO_ORG}
            checked={shippingChoice === SHIP_TO_ORG}
            onChange={() => handleShippingChoiceChange(SHIP_TO_ORG)}
            disabled={isChanging}
          />
          Ship to Organization
        </label>
      )}

      {/* Display disclaimer text at the bottom */}
      {shippingChoice && (
        <p className="shipping-disclaimer">{getDisclaimerText()}</p>
      )}
    </div>
  );
};

export default ShippingChoices;
